export type BalloonOutcome = 'correct-hit' | 'wrong-hit' | 'correct-miss' | 'wrong-miss' | 'untouched-exit';

export interface GameProgress {
  score: number;
  lives: number;
  streak: number;
  correct: number;
  wrong: number;
  attempts: number;
}

export function createInitialProgress(): GameProgress {
  return { score: 0, lives: 3, streak: 0, correct: 0, wrong: 0, attempts: 0 };
}

export function correctAnswerPoints(streakBeforeAnswer: number): number {
  return Math.min(140, 100 + Math.max(0, streakBeforeAnswer) * 10);
}

export function applyBalloonOutcome(progress: GameProgress, outcome: BalloonOutcome): GameProgress {
  if (outcome === 'correct-hit') {
    return {
      ...progress,
      score: progress.score + correctAnswerPoints(progress.streak),
      streak: progress.streak + 1,
      correct: progress.correct + 1,
      attempts: progress.attempts + 1,
    };
  }

  if (outcome === 'wrong-hit') {
    return {
      ...progress,
      score: Math.max(0, progress.score - 25),
      lives: Math.max(0, progress.lives - 1),
      streak: 0,
      wrong: progress.wrong + 1,
      attempts: progress.attempts + 1,
    };
  }

  return progress;
}
